import Vue from "vue";
import VueRouter from "vue-router";
import login from "@/pages/auth/login.vue";
import signup from "@/pages/auth/signup.vue";
import home from "@/pages/Home.vue";
import intro from "@/pages/Intro.vue";
import details from "@/pages/Details.vue";
import contact from "@/pages/Contact.vue";
import Terms from "@/pages/Terms.vue";
import CookiesPrivacy from "@/pages/CookiesPrivacy.vue";
import Faqs from "@/pages/Faqs.vue";
import search from "@/pages/Search.vue";
import mediaCenter from "@/pages/mediaCenter.vue";
import VideoScreen from "@/pages/VideoScreen.vue";
import DetailsList from "@/pages/DetailsList.vue";
import DetailSeries from "@/pages/DetailSeries.vue";
import Emailverify from "@/pages/auth/emailverify.vue";
import CheckEmailverification from "@/pages/auth/checkEmailVerification.vue";
import ConfirmEmailverification from "@/pages/auth/confirmEmailVerification.vue";
import verifyByEmail from "@/pages/auth/verifyByEmail.vue";
import verifyByPhone from "@/pages/auth/verifyByPhone.vue";
import verifyUpdatePhone from "@/pages/auth/verifyUpdatePhone.vue";
import Resetpassword from "@/pages/auth/resetpassword.vue";
import Forgotpassword from "@/pages/auth/forgotpassword.vue";
import ForgotPasswordEmail from "@/pages/auth/forgotPasswordEmail.vue";
import UpdatepasswordEn from "@/pages/auth/updatepassword.vue";
import GetCodeResetPhone from "@/pages/auth/getCodeResetPhone.vue";
import TopUpPage from "@/pages/payment/TopUpPage.vue";
import SelectPaymentNig from "@/pages/payment/SelectPaymentNig.vue";
import SelectPaymentAfr from "@/pages/payment/SelectPaymentAfr.vue";
import SelectPaymentDsp from "@/pages/payment/SelectPaymentDsp.vue";
import CheckoutPage from "@/pages/payment/CheckoutPage.vue";
import CashPayment from "@/pages/payment/CashPayment.vue";
import FlutterWavePayment from "@/pages/payment/FlutterWavePayment.vue";
import Profile from "@/pages/profile/Profile.vue";
import Profile1 from "@/pages/profile/Profile1.vue";
import Profile2 from "@/pages/profile/Profile2.vue";
// import Profile3 from "@/pages/profile/Profile3.vue";
import UpdatePhone from "@/pages/profile/UpdatePhone.vue";
import UpdateEmail from "@/pages/profile/UpdateEmail.vue";
import UpdatePassword from "@/pages/profile/UpdatePassword.vue";
import Packages from "@/pages/Packages.vue";
import Account from "@/pages/Account.vue";
import Videoplayer from "@/pages/player/VideoPlayer.vue";
import VideoPlayerSeries from "@/pages/player/VideoPlayerSeries.vue";
import DashVideo from "@/pages/player/DashVideo.vue";
import PaymentResFlutterwave from "@/pages/payment/PaymentResFlutterWave.vue";
import PaymentResStripe from "@/pages/payment/PaymentResStripe.vue";
import ViewVideo from "@/pages/ViewVideo.vue";
import PageNotFound from "@/pages/pagenotfound/PageNotFound404.vue";
import PageNotFound2 from "@/pages/pagenotfound/PageNotFound2.vue";
import ListMovies from "@/pages/list/ListMovies.vue";
import ListMyList from "@/pages/list/ListMyList.vue";
import ListRecent from "@/pages/list/ListRecent.vue";
import ListSeries from "@/pages/list/ListSeries.vue";
import StripePayment from "@/pages/payment/StripePayment.vue";
import ProcessDpo from "@/pages/payment/ProcessDpo.vue";
import PaymentResDpo from "@/pages/payment/PaymentResDpo.vue";
import Payment from "@/pages/payment/Payment.vue";
import ConfirmSubscription from "@/pages/payment/ConfirmSubscription.vue";
import ChangeSubscription from "@/pages/payment/ChangeSubscription.vue";
import Subscription from "@/pages/payment/Subscription.vue";
import Subscription1 from "@/pages/payment/Subscription1.vue";
import Popup from "@/pages/Popup.vue";
import SpecialPlanPopUp from "@/pages/SpecialPlanPopUp.vue"
import StripePaymentSetUpCard from "@/pages/payment/StripePaymentSetUpCard.vue";
import StripeRenewUpdateCard from "@/pages/payment/StripeRenewUpdateCard.vue";
import BraintreeRenewUpdateCard from "@/pages/payment/BraintreeRenewUpdateCard.vue"
import StripeCheckout from "@/pages/payment/StripeCheckout.vue";
import DeleteAccount from "@/pages/DeleteAccount.vue"
Vue.use(VueRouter);
const router = new VueRouter({
    routes: [
          {
            path: "/",
            name: "intro",
            component: intro,
        },
       
      
        {
            path: "/search",
            name: "search",
            component: search,
        },
        {
            path: "/packages",
            name: "Packages",
            component: Packages,
        },
        {
            path: "/login",
            name: "login",
            component: login,
        },
        {
            path: "/signup",
            name: "signup",
            component: signup,
        },
        {
            path: "/faqs",
            name: "faqs",
            component: Faqs,
        },
        {
            path: "/mediacenter",
            name: "mediaCenter",
            component: mediaCenter,
        },
        {
            path: "/home",
            name: "home",
            component: home,
        },
        {
            path: "/listmovies",
            name: "listMovies",
            component: ListMovies,
        },
        {
            path: "/listmylist",
            name: "ListMyList",
            component: ListMyList,
        },
        {
            path: "/listrecent",
            name: "ListRecent",
            component: ListRecent,
        },
        {
            path: "/listseries",
            name: "ListSeries",
            component: ListSeries,
        },
        {
            path: "/contact",
            name: "contact",
            component: contact,
        },
        {
            path: "/details/:vid/:catid",
            name: "details",
            component: details,
        },
        {
            path: "/playlistdetails/:catid",
            name: "DetailsList",
            component: DetailsList,
        },
        {
            path: "/detailseries/:catid",
            name: "DetailSeries",
            component: DetailSeries,
        },
        {
            path: "/terms",
            name: "Terms",
            component: Terms,
        },
        {
            path: "/popup",
            name: "Popup",
            component: Popup,
        },
        {
            path: "/specialplanpopup",
            name: "SpecialPlanPopUp",
            component: SpecialPlanPopUp,
        },
        {
            path: "/cookiesprivacy",
            name: "CookiesPrivacy",
            component: CookiesPrivacy,
        },
        {
            path: "/emailverify",
            name: "Emailverify",
            component: Emailverify,
        },
        {
            path: "/checkemailverify",
            name: "checkemailverify",
            component: CheckEmailverification,
        },
        {
            path: "/confirmemailverify",
            name: "confirmemailverify",
            component: ConfirmEmailverification,
        },
        {
            path: "/reset-phone-code",
            name: "GetCodeResetPhone",
            component: GetCodeResetPhone,
        },
        {
            path: "/resetpassword",
            name: "Resetpassword",
            component: Resetpassword,
        },
        {
            path: "/forgotpassword",
            name: "Forgotpassword",
            component: Forgotpassword,
        },
        {
            path: "/forgotpasswordemail",
            name: "ForgotPasswordEmail",
            component: ForgotPasswordEmail,
        },
        {
            path: "/verifybyemail",
            name: "verifyByEmail",
            component: verifyByEmail,
        },
        {
            path: "/verifyupdatephone",
            name: "verifyUpdatePhone",
            component: verifyUpdatePhone,
        },
        {
            path: "/verifybyphone",
            name: "verifyByPhone",
            component: verifyByPhone,
        },
        {
            path: "/topuppage",
            name: "TopUpPage",
            component: TopUpPage,
        },
        {
            path: "/selectpayment-dsp/:sid/:pid",
            name: "SelectPaymentDsp",
            component: SelectPaymentDsp,
        },
        {
            path: "/selectpayment-afr/:sid/:pid",
            name: "SelectPaymentAfr",
            component: SelectPaymentAfr,
        },
        {
            path: "/selectpayment-nig/:sid/:pid",
            name: "SelectPaymentNig",
            component: SelectPaymentNig,
        },
        {
            path: "/checkout/:sid/:pid",
            name: "CheckoutPage",
            component: CheckoutPage,
        },
        {
            path: "/stripecheckout/:sid/:pid",
            name: "StripeCheckout",
            component: StripeCheckout,
        },
        {
            path: "/cashpayment/:sid/:pid/",
            name: "CashPayment",
            component: CashPayment,
        },
        {
            path: "/flutterwavepayment/:sid/:pid",
            name: "FlutterWavePayment",
            component: FlutterWavePayment,
        },
        {
            path: "/play/:vid/:catid",
            name: "VideoScreen",
            component: VideoScreen,
        },
        {
            path: "/updatepassword-en/:id",
            name: "UpdatepasswordEn",
            component: UpdatepasswordEn,
        },
        {
            path: "/account",
            name: "Account",
            component: Account,
        },
        {
            path: "/profile",
            name: "Profile",
            component: Profile,
        },
        {
            path: "/profile1",
            name: "Profile1",
            component: Profile1,
        },
        {
            path: "/profile2",
            name: "Profile2",
            component: Profile2,
        },

        {
            path: "/updatephone",
            name: "UpdatePhone",
            component: UpdatePhone,
        },
        {
            path: "/update-email",
            name: "UpdateEmail",
            component: UpdateEmail,
        },
        {
            path: "/update-password",
            name: "UpdatePassword",
            component: UpdatePassword,
        },
        {
            path: "/playvideo/:vid",
            name: "Videoplayer",
            component: Videoplayer,
        },
        {
            path: "/videoplayerseries",
            name: "VideoPlayerSeries",
            component: VideoPlayerSeries,
        },
        {
            path: "/viewvideo/:vid",
            name: "ViewVideo",
            component: ViewVideo,
        },
        {
            path: "/dashvideo",
            name: "DashVideo",
            component: DashVideo,
        },
        {
            path: "/payment/:sid/:pid",
            name: "Payment",
            component: Payment,
        },
        {
            path: "/confirmsubscription",
            name: "ConfirmSubscription",
            component: ConfirmSubscription,
        },
        {
            path: "/changesubscription",
            name: "ChangeSubscription",
            component: ChangeSubscription,
        },
        {
            path: "/subscription",
            name: "Subscription",
            component: Subscription,
        },
        {
            path: "/payment-res",
            name: "PaymentResFlutterwave",
            component: PaymentResFlutterwave,
        },
        {
            path: "/stripe-res/:sid/:pid",
            name: "PaymentResStripe",
            component: PaymentResStripe,
        },
        {
            path: "/process-dpo/:sid/:pid",
            name: "processDpo",
            component: ProcessDpo,
        },
        {
            path: "/paymentres-dpo",
            name: "paymentResDpo",
            component: PaymentResDpo,
        },
        {
            path: "/stripepayment/:sid/:pid",
            name: "StripePayment",
            component: StripePayment,
        },
        {
            path: "/striperenewupdatecard",
            name: "StripeRenewUpdateCard",
            component: StripeRenewUpdateCard,
        },
        {
            path: "/braintreerenewupdatecard",
            name: "BraintreeRenewUpdateCard",
            component: BraintreeRenewUpdateCard,
        },
        {
            path: "/stripe-setup-card",
            name: "StripePaymentSetUpCard",
            component: StripePaymentSetUpCard,
            },
            
        {
            path: "/subscription1",
            name: "Subscription1",
            component: Subscription1,
        },
        {
            path: "/deleteaccount",
            name: "DeleteAccount",
            component: DeleteAccount,
        },
        {
            path: "/PageNotFound2",
            name: "PageNotFound2",
            component: PageNotFound,
        },
        {
            path: "/404",
            component: PageNotFound2,
        },
        {
            path: "*",
            redirect: "/404",
        },
        
        
    ],
});
// router.beforeEach((to, from, next) => {
//   // redirect to login page if not logged in and tryin
//   if (to.path == '/') {
//       next('/intro');
//   }else{
//     next();
//   }
//  // next();
// })
export default router;